import { Component, OnInit } from '@angular/core';
import Amplify from 'aws-amplify';

import { UserService } from './core/services/user.service';

Amplify.configure({
  Auth: {
    region: 's-west-2',
    identityPoolRegion: 's-west-2',
    userPoolId: 'us-west-2_lDDhRuxZ8',
    userPoolWebClientId: '46r9fhacab2v98n6gl7q3htpm0',
    mandatorySignIn: false,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.populate();
  }
}
